import { call, put, takeLatest } from 'redux-saga/effects';

import {
  LOAD_NEW_CONTENT,
  LOAD_NEW_CONTENT_SUCCESS,
  LOAD_POPULAR_CONTENT,
  LOAD_POPULAR_CONTENT_SUCCESS,
  LOAD_SEARCH_CONTENT,
  LOAD_SEARCH_CONTENT_SUCCESS,
} from './constants';

import { templateService } from '~/services';
import { USER_ROLES } from '~/config';

function* loadNewContent(action) {
  const { page, role, lang } = action.payload;
  try {
    const { templates, total, numberPages, page: currentPage } = yield call(
      templateService.listNewTemplates,
      {
        page: page || 1,
        max_results: 100,
        role: role || 'user',
        lang,
      },
    );

    templates.forEach((item) => {
      try {
        item.titles = JSON.parse(item.title);
        item.title = item.titles['title_original'] || item.titles['title_jp'];
      } catch (err) {
        item.titles = item.title;
        item.title = '';
      } finally {
        item.title = item.title || '';
      }
    });

    yield put({
      type: LOAD_NEW_CONTENT_SUCCESS,
      payload: {
        templates,
        total,
        currentPage,
        numberPages,
      },
    });
  } catch (error) {
    console.log(error);
  }
}

function* loadPopularContent(action) {
  const { page } = action.payload;
  try {
    const { templates, total, numberPages, page: currentPage } = yield call(
      templateService.listPopularTemplates,
      {
        page: page || 1,
        max_results: 100,
      },
    );

    templates.forEach((item) => {
      try {
        item.titles = JSON.parse(item.title);
        item.title = item.titles['title_original'] || '';
      } catch (err) {
        item.titles = item.title;
        item.title = '';
      }
    });

    yield put({
      type: LOAD_POPULAR_CONTENT_SUCCESS,
      payload: {
        templates,
        total,
        currentPage,
        numberPages,
      },
    });
  } catch (error) {
    console.log(error);
  }
}

function* loadSearchContent(action) {
  const { keyword, page, role, lang } = action.payload;
  try {
    const {
      collection,
      total_item,
      total_page,
      page: currentPage,
    } = yield call(templateService.searchTemplates, {
      keyword,
      page: page || 1,
      max_results: 100,
      role: role || USER_ROLES.USER,
      lang: lang || 'jp',
    });
    collection.forEach((item) => {
      if (item.title) {
        try {
          item.titles = JSON.parse(item.title);
          item.title = item.titles['title_original'] || '';
        } catch (err) {
          item.titles = item.title;
          item.title = '';
        }
      } else {
        item.title = '';
      }
    });
    yield put({
      type: LOAD_SEARCH_CONTENT_SUCCESS,
      payload: {
        templates: collection,
        total: total_item,
        currentPage: parseInt(currentPage),
        numberPages: total_page,
      },
    });
  } catch (error) {
    console.log(error);
  }
}

export default function* categorySaga() {
  yield takeLatest(LOAD_NEW_CONTENT, loadNewContent);
  yield takeLatest(LOAD_POPULAR_CONTENT, loadPopularContent);
  yield takeLatest(LOAD_SEARCH_CONTENT, loadSearchContent);
}
